import { Component, Injector, OnInit } from "@angular/core";
import { IColourPickerPresetGroups } from "@common/ux/colour-picker/colour-picker.component";
import { WorkflowStepComponent } from "@org-common/lib/workflow/workflow-component-registry";
import { AddTeamWorkflowStepBaseComponent } from "../add-team-workflow-step-base.component";

@WorkflowStepComponent("adapt-add-team-customise-step")
@Component({
    selector: "adapt-add-team-customise-step",
    templateUrl: "./add-team-customise-step.component.html",
    styleUrl: "./add-team-customise-step.component.css",
    standalone: false,
})
export class AddTeamCustomiseStepComponent extends AddTeamWorkflowStepBaseComponent implements OnInit {
    public colourPresetGroups?: IColourPickerPresetGroups;

    public constructor(
        injector: Injector,
    ) {
        super(injector);
    }

    public get team() {
        return this.runData.team;
    }

    public async ngOnInit() {
        this.colourPresetGroups = await this.teamsService.promiseToGetUsedTeamBackgroundColourPresetGroup();
    }
}
